import React from 'react';
import useOrganizationGroups from '../../../../../../../hooks/api/useOrganizationGroups';
import { useIsDisabledByParent } from '../../../../../../v2BaseComponents/IsDisabledProvider';
import { AnimateLoadedContent } from '../../../../../../v2BaseComponents/Loader';
import EditGroupForm from './EditGroupForm';

export type EditGroupSideDrawerContentOwnProps = {
    groupId: string;
    onClose: (force: boolean) => void;
};

export type EditGroupSideDrawerContentProps = EditGroupSideDrawerContentOwnProps;

const EditGroupSideDrawerContent: React.FC<EditGroupSideDrawerContentProps> = ({ groupId, onClose }) => {
    const { isUpdatingGroup, updateGroup, group, isLoadingGroup } = useOrganizationGroups({
        onUpdateGroupSuccess: () => onClose(true),
        groupId: groupId,
    });
    const isDisabledByParent = useIsDisabledByParent(isUpdatingGroup);

    return (
        <AnimateLoadedContent isLoading={isLoadingGroup || !group}>
            {() => (
                <EditGroupForm
                    group={group!}
                    onUpdate={(group) => updateGroup({ groupId: groupId, group })}
                    isDisabled={isDisabledByParent}
                    onCancel={() => onClose(true)}
                />
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditGroupSideDrawerContent);
